import ReactDOM from 'react-dom/client';
import App from './App.tsx';
// @ts-ignore
import './index.css';
import { ThemeProvider } from '@zendeskgarden/react-theming';
import { StrictMode } from 'react';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
